// extracted by mini-css-extract-plugin
export default {"wrapper":"PrintBlock_wrapper__Ig0QA","wrapper_disabled":"PrintBlock_wrapper_disabled__sRMWc","spin":"PrintBlock_spin__7aO3i"};